import { BASE_API } from '../utils';

export interface ShowConfig {
  baseURL: string;
  method: 'GET';
  url: `/skills/${string}/example`;
}

/**
 * GET /vo/v1/skills/{id}/example
 */
export const show = (skillId: string): ShowConfig => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/skills/${skillId}/example`,
  } as const;
};
